import React, { Fragment } from 'react';
import { ajax, setEmptyStrings, Environment, myDeepCopy, showPopup, loadRegionZips } from '../components/globals';
import { Languages } from '../components/languages';
import { ConfiguratedList, ListButton, LogoList, ModalBoxFluid, UButton, UButtonGroup, UCardTitle, UCheckbox, USearch, UCheckboxFlat, UInput, ULabel, USelect, MessageBox } from '../components/utilities';

import { PageTitle, ScrollableGrid, ScrollableGridItem, UIPopup, UIInput, UIButton, UIButtonPad, UICheckbox, UIMessageBox, UISelect, UIMultiSelect } from '../components/guiElements';




export default class Couriers extends React.Component {

    constructor(props) {
        super(props);


        this.uc = JSON.parse(sessionStorage.getItem("userContext"));
        this.le = Languages.getSection('Couriers');
        this.leMain = Languages.getSection('Main');

        this.state = {
            filter: '',
            rules: this.buildRules(),
            regions: [],
        };

        this.filterChange = this.filterChange.bind(this);
        this.logoClick = this.logoClick.bind(this);

        this.deleteDetail = this.deleteDetail.bind(this);
    }

    filterChange(ev) {
        this.setState({ filter: ev.target.value });
    }

    loadCarrierConfs() {//esistenti
        ajax(this, { method: 'get', url: '/api/carrier/carrier-conf', headers: { Authorization: 'Bearer ' + this.uc.jwtToken } },
            response => {
                let courierList = response.data.result.carriers;
                this.le.rules.courierOpts = this.le.rules.courierSel.map((el) => ({ value: '', text: el })).concat(courierList.map((el) => ({ value: el.id, text: el.name })));
                this.setState({ carrierListConf: courierList });
            },
            error => { }
        );
    }

    loadCarrierSets() {//selezionati
        ajax(this, { method: 'get', url: '/api/carrier/carriers-sets', headers: { Authorization: 'Bearer ' + this.uc.jwtToken } },
            response => {
                let newDetails = [];
                for (let i = 0; i < response.data.result.carriers.length; i++) {
                    let det = response.data.result.carriers[i];
                    newDetails[det.id] = Object.assign({ flag: det.chkRules }, det);
                }
                this.setState({ allDetails: newDetails });
            },
            error => { }
        );
    }

    componentDidMount() {
        //this.le.rules.countersignOpts = this.le.rules.countersignSel.map((el) => ({ value: el, text: el }));
        this.le.rules.packageOpts = this.le.rules.packageSel.map((el) => ({ value: el, text: el }));
/*        this.le.rules.packageMinOpts = [{ value: 0, text: '' }];
        this.le.rules.packageMaxOpts = [{ value: 0, text: '' }];
        for (let i = 1; i <= this.le.rules.packageMinSel; i++)
            this.le.rules.packageMinOpts.push({ value: i, text: i });
        for (let i = 1; i <= this.le.rules.packageMaxSel; i++)
            this.le.rules.packageMaxOpts.push({ value: i, text: i });
*/
        ajax(this, { method: 'get', url: '/api/param/region', headers: { Authorization: 'Bearer ' + this.uc.jwtToken } },
            response => {
                let regions = response.data.sort((a, b) => ((a.name < b.name) ? -1 : ((a.name > b.name) ? 1 : 0)));
                this.le.rules.regionOpts = this.le.rules.regionSel.map((el) => ({ value: '', text: el })).concat(regions.map((el) => ({ value: el.idregion, text: el.name })));
                this.setState({ regions: regions });
                this.loadCarrierConfs();
                this.loadCarrierSets();
            },
            error => { }
        );
    }



    buildEmptyDetails(source) {
        let details = {};
        const basicDetails = this.state.carrierListConf.find(el => (el.name === source)).details;
        basicDetails.forEach(el => {
            if (el.typePar == 'text')
                details[el.id] = el.value;
            else if (el.typePar !== 'checkbox')
                details[el.id] = false;
        });
        return details;
    }

    buildListDetail(name, values) {
        let basicDetails = myDeepCopy(this.state.carrierListConf.find(el => (el.name === name)).details);
        basicDetails.forEach(el => { if (el.typePar !== 'label' && el.id in values) el.value = values[el.id]; });
        return basicDetails;
    }

    buildRules(/*nobkp*/details) {
        let output = {
            id: null,
            carrierOrganization: details ? details.id : null,
            courier: details ? details.id : null,
            region: null,
            hasCounterSign: false,
            //countersign: this.le.rules.countersignSel[2],
            countersign: '',
            package: this.le.rules.packageSel[2],
            zipSelection: [],
            //zipSelectionBackup: [],
            packageMin: '',
            packageMax: '',
            minSize: '',
            maxSize: '',
            minWeight: '',
            maxWeight: '',
            minWeightTot: '',
            maxWeightTot: ''
        };
        if (this.state && this.state.carrierListConf && details)
            Object.assign(output, this.state.carrierListConf.find(el => (el.id === details.carrierId)).rulePreset);
        return output;
    }

    buildDetails(source, id) {
        let details = this.buildEmptyDetails(source);
        let chkRules = false;
        let carrierId = null;
        let name = source;
        if (id != null && id in this.state.allDetails) {

            let det = this.state.allDetails[id];

            for (let i = 0; i < det.details.length; i++) {
                let key = det.details[i].id;
                if (key in details)
                    details[key] = det.details[i].value;
            }
            chkRules = det.chkRules;
            carrierId = det.carrierId;
        }
        return Object.assign({ id: id, name: name, carrierId: carrierId, chkRules: chkRules, details: details });
    }

    logoClick(ev, name, id) {
        let details = this.buildDetails(name, id);
        this.setState({ modalTarget: 'courier' /*1*/, logoName: name, details: details });
    }


    deleteDetail(ev, source) {
        this.props.loaderShow(0);
        let newDetails = this.state.allDetails;

        if (!source in newDetails) return;

        let id = newDetails[source].id;

        ajax(this, { method: 'post', url: '/api/carrier/carriers-set-delete/' + id, headers: { Authorization: 'Bearer ' + this.uc.jwtToken } },
            response => {
                this.props.loaderHide();
                delete newDetails[source];
                this.setState({ allDetails: newDetails });
            },
            error => {
                this.props.loaderHide();
                this.props.popupErrorMessage("");//Languages.getSection('Main').messages.msgError);

            }
        );
    }

    detailsChange(ev) {
        let name = ev.target.name;
        let val = (ev.target.type == 'checkbox' || ev.target.type == 'radio') ? ev.target.checked : ev.target.value;
        let details = JSON.parse(JSON.stringify(this.state.details));
        if (name in details.details)
            details.details[name] = val;
        else
            details[name] = val;
        this.setState({ details: details });
    }

    detailClick(ev, response) {
        if (response) {

            this.props.loaderShow();

            ajax(this, { method: 'post', url: '/api/carrier/carriers-set', headers: { Authorization: 'Bearer ' + this.uc.jwtToken }, data: this.state.details },
                response => {
                    this.props.loaderHide();
                    let id = response.data.result.id;
                    let newDetails = this.state.allDetails;
                    newDetails[id] = Object.assign({ flag: this.state.details.chkRules }, this.state.details);
                    newDetails[id].id = id;
                    newDetails[id].details = this.buildListDetail(newDetails[id].name, newDetails[id].details);
                    this.setState({ allDetails: newDetails });
                    this.setState({ logoName: '', modalTarget: null });

                    // check if the courier hasn't yet configured the rules, if so open the frame automatically
                    /*if (false && !this.state.details.chkRules) {
                        let rules = JSON.parse(JSON.stringify(this.state.rules));
                        rules.courier = this.state.logoName;
                        this.setState({ showRules: true, rules: rules });
                    }*/
                },
                error => {
                    this.props.loaderHide();
                    this.props.popupErrorMessage("");//Languages.getSection('Main').messages.msgError);
                }
            );

        }
        else {
            this.setState({ logoName: '', modalTarget: null });
        }
    }

    rulesChange(ev) {
        let name = ev.target.name;
        let val = ev.target.value;
        let rules = JSON.parse(JSON.stringify(this.state.rules));
        
        if (name == 'zipSelection') {
            rules[name] = val.split(',');
            this.setState({ rules: rules });
        }
        else if (name == 'region') {
            // load zip codes
            loadRegionZips(this.uc.jwtToken, val,
                response => {
                    this.props.loaderHide();
                    rules[name] = val;
                    rules.zipSelection = [];
                    this.setState({ rules: rules, regionZips: response });
                },
                error => {
                    this.props.loaderHide();
                    this.props.popupErrorMessage("");
                });

        }
        else {
            rules[name] = val;
            this.setState({ rules: rules });
        }
    }

    rulesClick(ev, action) {
        try {
            if (action) {
                let rules = JSON.parse(JSON.stringify(this.state.rules));
                rules.carrierOrganization = this.state.details.id;
                this.props.loaderShow(0);
                ajax(this, { method: 'post', url: '/api/carrier/carriers-rule', headers: { Authorization: 'Bearer ' + this.uc.jwtToken }, data: rules },
                    response => {
                        this.props.loaderHide();
                        this.setState({ modalTarget: null });
                    },
                    error => {
                        this.props.loaderHide();
                        this.props.popupErrorMessage("");
                    }
                );
            }
            else {
                let rules = JSON.parse(JSON.stringify(this.state.rules));
                this.setState({ modalTarget: null });

            }
        }
        catch (e) {
            this.props.loaderHide();
        }
    }

    listButtonClick(ev, name, type, source) {
        if (type === 'remove') {
            this.setState({
                messageBox: <UIMessageBox type="question" title={this.le.popup.deletePopup.title} message={this.le.popup.deletePopup.message}>
                    <UIButton className="" text={this.le.popup.cancelText} onClick={(ev) => this.setState({ messageBox: null })} />
                    <UIButton className="confirm" text={this.le.popup.confirmText} onClick={(ev) => { this.setState({ messageBox: null }); this.deleteDetail(ev, source) }} />
                </UIMessageBox>
            });
        }
        else if (type === 'edit') {
            let newDetails = this.state.allDetails;
            if (!source in newDetails)
                return;
            this.logoClick(ev, newDetails[source].name, newDetails[source].id);
        }
        else if (type === 'disable') {
            /* attualmente non previsto */
        }
        else if (type === 'rules') {
            const newDetails = this.state.allDetails;
            const detail = newDetails[source];
            

            if (!(source in newDetails)) {
                // new...
                this.setState({ modalTarget: 'rules', rules: this.buildRules(detail), details: detail });
                return;
            }
            else {
                // load from BE...
                this.props.loaderShow();
                ajax(this, { method: 'get', url: '/api/carrier/carriers-rules/' + detail.id, headers: { Authorization: 'Bearer ' + this.uc.jwtToken } },
                    response => {
                        if (response.data.result.rules.length == 0) {
                            response.data.result.rules.push(this.buildRules(detail));
                        }

                        let rules = response.data.result.rules[0];
                        rules.zipSelection = rules.zipSelection || [];//(rules.zipSelection ? rules.zipSelection.split(',') : null) || [];
                        rules.hasCounterSign = detail.counterSign;
                        rules.courier = source;
                        //rules.zipSelectionBackup = rules.zipSelectionBackup || [];
                        if (rules.region) {
                            // load zip codes
                            loadRegionZips(this.uc.jwtToken, rules.region,
                                response => {
                                    this.props.loaderHide();
                                    this.setState({ modalTarget: 'rules', rules: rules, details: detail, regionZips: response });
                                },
                                error => {
                                    this.props.loaderHide();
                                    this.props.popupErrorMessage("");
                                });
                        }
                        else {
                            this.props.loaderHide();
                            this.setState({ modalTarget: 'rules', rules: rules, details: detail });
                        }
                    },
                    error => {
                        this.props.loaderHide();
                        this.props.popupErrorMessage("");
                    }
                );
            }
        }
        else if (type === 'addrule') {

        }
        else alert(`name: ${name}, type: ${type}, source: ${source}`);
    }

    buildDetailPopup() {

        const dVal = this.state.details;
        let le = this.le.details;
        const items = this.state.carrierListConf.find(el => (el.name === this.state.logoName)).details.map(el => {
            let item = null;
            let val = dVal.details[el.id];
            let text = (el.id in le) ? le[el.id] : el.id;

            switch (el.typePar) {
                case "text":
                    item = <UIInput key={el.id} name={el.id} value={val} label={text} hint={text} onChange={(ev) => this.detailsChange(ev)} />
                    break;
                case "checkbox":
                    item = <UICheckbox key={el.id} name={el.id} value={val} label={text} onChange={(ev) => this.detailsChange(ev)} />
                    break;
                default:
                    item = <div key={el.id}>{le[el.id]}</div>;
                    break
            }
            return item;
        });

        return <UIPopup
            className="couriers"
            title={this.state.logoName}
            onCancel={(ev) => (this.detailClick(ev, false))}
            buttons={[
                <UIButton key="btn-1" className="" text={le.btnCancel} onClick={(ev) => this.detailClick(ev, false)} />,
                <UIButton key="btn-2" className="confirm" text={le.btnOk} onClick={(ev) => this.detailClick(ev, true)} />
            ]}>
            <UICheckbox name="chkRules" value={dVal.chkRules} label={le.chkRules} onChange={(ev) => this.detailsChange(ev)} />
            <div className="flex-panel">
                {dVal.chkRules ? [] : items}
            </div>

        </UIPopup>;
    }

    buildRulesPopup() {
        const dVal = this.state.details;
        let le = this.le;
        let texts = le.rules;
        let headers = [texts.province, texts.zipCode];
        let zips = this.state.regionZips ? this.state.regionZips.map(
            (el, idx) => ({ columns: [el.name, el.zip], value: el.name })
        ) : [];

        const countersignOpts = le.rules.countersignSel.filter((el,idx) => (this.state.details.counterSign ? true : idx >= 2)).map((el) => {
            return { value: el, text: el }
        });
        if (countersignOpts.length == 1) {
            this.state.rules.countersign = countersignOpts[0].value;
        }
        return <UIPopup
            className="couriers"
            title={texts.title}
            onCancel={(ev) => this.setState({ modalTarget: null })}
            buttons={[
                <UIButton key="btn-1" className="" text={texts.buttons[0]} onClick={(ev) => this.rulesClick(ev, false)} />,
                <UIButton key="btn-2" className="confirm" text={texts.buttons[1]} disabled={this.state.rules.readonly && this.state.rules.id != null}  onClick={(ev) => this.rulesClick(ev, true)} />
            ]}>
            <div className="popup-body-title">{this.le.messages[2].captions[0]}</div>
            <div className="flex-panel">
                <UISelect name="region" readOnly={this.state.rules.readonly} label={texts.region} options={texts.regionOpts} value={this.state.rules.region} onChange={(ev) => this.rulesChange(ev)} />
                <UIMultiSelect readOnly={this.state.rules.readonly} disabled={zips.length == 0} name="zipSelection" hint={zips.length == 0 ? '' : texts.capSel} label={texts.changeZip} headers={headers} options={zips} multiple={true} value={this.state.rules.zipSelection} onChange={(ev) => this.rulesChange(ev)} />
                <UISelect readOnly={this.state.rules.readonly} name="countersign" label={texts.countersign} options={countersignOpts} value={this.state.rules.countersign} onChange={(ev) => this.rulesChange(ev)} />
                <UISelect readOnly={this.state.rules.readonly} name="package" label={texts.package} options={texts.packageOpts} value={this.state.rules.package} onChange={(ev) => this.rulesChange(ev)} />

                <UIInput readOnly={this.state.rules.readonly} name="packageMin" value={this.state.rules.packageMin} label={texts.packageMin} onChange={(ev) => this.rulesChange(ev)} />
                <UIInput readOnly={this.state.rules.readonly} name="packageMax" value={this.state.rules.packageMax} label={texts.packageMax} onChange={(ev) => this.rulesChange(ev)} />

                <UIInput readOnly={this.state.rules.readonly} name="minSize" value={this.state.rules.minSize} label={texts.minSize} onChange={(ev) => this.rulesChange(ev)} />
                <UIInput readOnly={this.state.rules.readonly} name="maxSize" value={this.state.rules.maxSize} label={texts.maxSize} onChange={(ev) => this.rulesChange(ev)} />
                <UIInput readOnly={this.state.rules.readonly} name="minWeight" value={this.state.rules.minWeight} label={texts.minWeight} onChange={(ev) => this.rulesChange(ev)} />
                <UIInput readOnly={this.state.rules.readonly} name="maxWeight" value={this.state.rules.maxWeight} label={texts.maxWeight} onChange={(ev) => this.rulesChange(ev)} />
                <UIInput readOnly={this.state.rules.readonly} name="minWeightTot" value={this.state.rules.minWeightTot} label={texts.minWeightTot} onChange={(ev) => this.rulesChange(ev)} />
                <UIInput readOnly={this.state.rules.readonly} name="maxWeightTot" value={this.state.rules.maxWeightTot} label={texts.maxWeightTot} onChange={(ev) => this.rulesChange(ev)} />


            </div>
        </UIPopup>;
    }

    render() {
        let le = this.le;
        let icons = [];
        let rows = [];
        let modal = [];
        let datasetReady = this.state.carrierListConf && this.state.allDetails;


        if (datasetReady) {
            let x = 1;
            icons = this.state.carrierListConf.filter(el => el.name.toLowerCase().indexOf(this.state.filter.toLowerCase()) >= 0).map(
                (el, idx) => (<ScrollableGridItem key={(++x)} id={el.id} icon={el.logo} title={el.name} onClick={this.logoClick} />)
            );


            rows = Object.entries(this.state.allDetails).map(([key, value], idx) => (
                [<div className="entry-list-row-panel" key={"pan-1-"+key}>
                    <div className="entry-list-edit" onClick={(ev) => this.listButtonClick(ev, value.name, 'edit', value.id)} />
                    {/*<div className="entry-list-delete" onClick={(ev) => this.listButtonClick(ev, value.name, 'remove', value.id)} />*/}
                    <div className="entry-list-icon" style={{ backgroundImage: 'url(' + (this.state.carrierListConf.filter(i => i.name == value.name).map(i => i.logo)[0]) + ')' }} />
                    <div className="entry-list-text">{value.name}</div>
                </div>,
                <div className="entry-list-row-panel" key={"pan-2-" + key}>
                    <UIButton className="modify" text={le.list.editRules} onClick={(ev) => (this.listButtonClick(ev, value.name, 'rules', value.id))} />
                </div>,
                <div className="entry-list-row-panel" key={"pan-3-" + key}>
                    <div className={"entry-list-status disabled " + (value.flag ? '' : 'off')} onClick={(ev) => this.listButtonClick(ev, value.name, 'disable', value.id)}></div>
                    <div className="entry-list-text">{value.flag ? le.list.active : le.list.inactive}</div>
                </div>]
            ));
        }

        if (this.state.modalTarget == 'courier') {
            modal = this.buildDetailPopup();
        }
        else if (this.state.modalTarget == 'rules') {
            modal = this.buildRulesPopup();
        }


        return <div className="page-couriers">
            <PageTitle icon="../images/mainMenu/Couriers.png" title={Languages.getSection('Main').menuLabels.couriers} />
            <div className="page-content">


                <div className="widget hidden" key="wid1">
                    <div className="widget-content">
                        <div className="widget-content-title">{le.couriers.title}</div>
                        <div className="widget-content-subtitle">{le.couriers.info}</div>
                        <USearch rowClass="widget-content-search " search={le.couriers.search} value={this.state.filter} onChange={this.filterChange} />
                        <div className="widget-content-title">{le.couriers.allCouriers}</div>
                        <ScrollableGrid>
                            {icons}
                        </ScrollableGrid>
                    </div>
                </div>


                <div className="widget" key="wid2">
                    <div className="widget-content for-entry-list">
                        <div className="entry-list" key="list-1">
                            <div className="entry-list-row-panel entry-list-row-header" key="listh1">
                                <div>{le.list.courier}</div>
                            </div>
                            <div className="entry-list-row-panel entry-list-row-header" key="listh2">
                                <div>{le.list.rules}</div>
                            </div>
                            <div className="entry-list-row-panel entry-list-row-header" key="listh3">
                                <div />
                                <div className="">{le.list.status}</div>
                            </div>
                            {rows}
                        </div>
                        <UIButtonPad align="right">
                            <UIButton className="slim" text={le.list.addRules} onClick={(ev) => (this.listButtonClick(ev, null, 'addrule', null))} />
                        </UIButtonPad>
                    </div>
                </div>
            </div>
            {modal}
            {this.state.messageBox}
        </div>;
    }


}


